import { Observable, of as observableOf } from 'rxjs';

import { Injectable } from '@angular/core';
import { TaxonomyOption, TaxonomyServiceInterface } from '@vendasta/taxonomy';
import { map } from 'rxjs/operators';
import { ApiService } from '../api-service/api.service';

@Injectable({ providedIn: 'root' })
export class TaxonomyService implements TaxonomyServiceInterface {
  constructor(private apiService: ApiService) {}

  getTaxonomyFromTaxonomyId(taxonomyId: string[]): Observable<string> {
    return this.getTaxonomyListForIds(taxonomyId).pipe(map((taxonomies) => taxonomies.join(', ')));
  }

  getTaxonomyListForIds(ids: string[]): Observable<string[]> {
    if (!ids || ids.length === 0) {
      return observableOf([]);
    }

    const url = '/_ajax/v1/get-taxonomy/?' + ids.map((id) => 'taxid=' + id).join('&');
    return this.apiService.get(url);
  }

  getTaxonomyMapForIds(ids: string[]): Observable<Map<string, string>> {
    return this.getTaxonomyListForIds(ids).pipe(
      map((names) => {
        return new Map(ids.map<[string, string]>((id, index) => [id, names[index]]));
      }),
    );
  }

  getTaxonomyIds(): Observable<TaxonomyOption[]> {
    const url = '/_ajax/v1/list-taxonomies/';
    return this.apiService.get(url);
  }
}
